export default {
  title: 'Meine Kurse',
  searchPH: 'Suche nach Kursnamen',
  sortByName: 'Kursname',
  sortByDate: 'Hinzugefügt'
}



// WEBPACK FOOTER //
// ./src/i18n/mycourses/de.js